import Service from "../../Service";
const resource = "SpcTrafficViolation/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },

  save(prd, requestID) {
    return Service.post(resource + "save", prd, {
      params: { requestID },
    });
  },

  carrierslist(parameters, requestID) {
    return Service.post(resource + "trafficviolationcarrierslist", parameters, {
      params: { requestID },
    });
  },

  vehicleslist(parameters, requestID) {
    return Service.post(resource + "trafficviolationvehicleslist", parameters, {
      params: { requestID, ...parameters },
    });
  },
};
